import {
  CognitoIdentityProviderClient,
  ListUsersCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import { fetchAuthSession } from "aws-amplify/auth";

// env
const {
  REACT_APP_REGION,
  REACT_APP_CUSTOMER_POOL_ID,
} = process.env;

// Build a Cognito prefix filter. Cognito only supports "starts-with" (^=)
// and exact match (=) — NOT substring/contains search.
const buildFilter = (attribute, keyword) => {
  // Escape double quotes to avoid breaking the filter string
  const safe = String(keyword).replace(/"/g, '\\"');
  return `${attribute} ^= "${safe}"`;
};

const queryUsers = async (awsCredentials, { attribute, keyword }) => {
  const client = new CognitoIdentityProviderClient({
    region: REACT_APP_REGION,
    credentials: awsCredentials,
  });

  const command = new ListUsersCommand({
    UserPoolId: REACT_APP_CUSTOMER_POOL_ID,
    Limit: 15,
    Filter: buildFilter(attribute, keyword),
  });

  const res = await client.send(command);

  // Flatten Cognito's Attributes array into a plain object per user
  return (res.Users || []).map((user) => {
    const attrs = {};
    (user.Attributes || []).forEach((a) => {
      attrs[a.Name] = a.Value;
    });
    return {
      username: user.Username,
      sub: attrs.sub,
      status: user.UserStatus,
      enabled: user.Enabled,
      name: attrs.name || [attrs.given_name, attrs.family_name].filter(Boolean).join(" "),
      email: attrs.email,
      phone_number: attrs.phone_number,
      email_verified: attrs.email_verified,
    };
  });
};

const handler = async (arg, { rejectWithValue }) => {
  try {
    const { attribute = "email", keyword = "" } = arg || {};
    const cleaned = keyword.trim();

    if (!cleaned) {
      return [];
    }

    // normalizing case sensitive as how cognito search bar are 
    const normalized = attribute === "email" ? cleaned.toLowerCase() : cleaned;

    const { credentials } = await fetchAuthSession();
    const customers = await queryUsers(credentials, { attribute, keyword: normalized });

    return customers;
  } catch (error) {
    console.error("services.customers.listCustomers@handler", error);
    return rejectWithValue(error);
  }
};

const pending = (state) => ({ ...state, loading: true });

const fulfilled = (state, action) => ({
  ...state,
  loading: false,
  lists: action.payload,
});

const rejected = (state) => ({ ...state, loading: false });

export default {
  handler,
  pending,
  fulfilled,
  rejected,
};
